import React, { useEffect, useRef } from 'react';
import OpenSeadragon from 'openseadragon';
import './deepZoomViewer.scss';
import { useLanguage } from '../../LanguageContext';

/**
 * Viewer deep zoom IIIF (OpenSeadragon + Cantaloupe).
 * Riceve l'id della picture e carica /iiif/2/<id>/info.json
 * attraverso il proxy (dev server in locale, reverse proxy in produzione).
 */
const DeepZoomViewer = ({ pictureId, title, onClose }) => {
  const containerRef = useRef(null);
  const { selectedLanguage } = useLanguage();

  useEffect(() => {
    if (!containerRef.current || !pictureId) return undefined;
    const viewer = OpenSeadragon({
      element: containerRef.current,
      tileSources: [`/iiif/2/${pictureId}/info.json`],
      // icone dei controlli OSD servite da CDN (non incluse nel pacchetto npm)
      prefixUrl:
        'https://cdn.jsdelivr.net/npm/openseadragon@4.1/build/openseadragon/images/',
      showNavigator: true,
      navigatorPosition: 'BOTTOM_RIGHT',
      visibilityRatio: 1,
      minZoomLevel: 0.8,
      defaultZoomLevel: 0,
      gestureSettingsMouse: { clickToZoom: true, scrollToZoom: true },
    });
    return () => viewer.destroy();
  }, [pictureId]);

  return (
    <div className="deepzoom-wrapper">
      <div className="deepzoom-header">
        <span className="deepzoom-title">
          {title ||
            (selectedLanguage === 'it'
              ? 'Esplorazione ad alta risoluzione'
              : 'High-resolution exploration')}
        </span>
        <button
          type="button"
          className="btn btn-sm btn-outline-light deepzoom-close"
          onClick={onClose}
          aria-label={selectedLanguage === 'it' ? 'Chiudi' : 'Close'}
        >
          ✕ {selectedLanguage === 'it' ? 'Chiudi' : 'Close'}
        </button>
      </div>
      <div ref={containerRef} className="deepzoom-canvas" />
      <p className="deepzoom-hint">
        {selectedLanguage === 'it'
          ? 'Usa la rotella o il doppio click per ingrandire, trascina per spostarti.'
          : 'Use the mouse wheel or double click to zoom, drag to pan.'}
      </p>
    </div>
  );
};

export default DeepZoomViewer;
